import React from "react";
import "./WhatsAppButton.scss"; // CSS file for styling
import { FaWhatsapp } from "react-icons/fa"; // Using react-icons for WhatsApp logo

const WhatsAppButton = () => {
  const phoneNumber = "+923491589717"; // Replace with your WhatsApp number
  const message = "Hello! I have a query about your trips."; // Default message

  return (
    <a
      href={`https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`}
      className="whatsapp-btn"
      target="_blank"
      rel="noopener noreferrer"
    >
      <FaWhatsapp size={40} />
    </a>
  );
};

export default WhatsAppButton;
